import type { ReactNode } from "react";

export type EmptyStateProps = {
  /** One-line diagnostic message in calibrate voice (no praise, no exclamations). */
  message: string;
  /** Optional action button or link below the message. */
  action?: ReactNode;
};

/**
 * EmptyState — standardized empty-state block per Design Review §8.
 * Voice rules from break-the-hidden-test-design-system/project/README.md:
 *   • diagnostic, no praise, no exclamations
 *   • "Find your patterns" not "Train your snap"
 *   • "No patterns yet. Try a session and we'll start showing them here."
 */
export function EmptyState({ message, action }: EmptyStateProps) {
  return (
    <div className="bht-empty-state" role="status">
      <div className="bht-empty-state__rule" aria-hidden />
      <p className="bht-empty-state__message">{message}</p>
      {action && <div className="bht-empty-state__action">{action}</div>}
    </div>
  );
}
